import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Icon,
  Stack,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import pluralize from "pluralize";
import * as React from "react";
import { BiTimer } from "react-icons/bi";
import { ISubjectStore } from "../stores";
import { SubjectGroupSelection } from "./SubjectComponents";

interface SubjectCreationTimerProps {
  icon: React.ReactElement;
  title: string;
  children: React.ReactNode;
  isRecommended?: boolean;
  onClickEnable?: React.MouseEventHandler;
}

export const SubjectCreationTimer = (props: SubjectCreationTimerProps) => {
  const { title, children, icon, isRecommended, onClickEnable } = props;
  return (
    <Stack spacing="5" justify="space-between" pos="relative">
      <Stack
        direction={{ base: "column", sm: "row" }}
        spacing="4"
        align="flex-start"
        flex="1"
      >
        <Box aria-hidden>{icon}</Box>
        <Box flex="1">
          <Box as="h4" fontWeight="bold" maxW="xl">
            {title}
          </Box>
          <Box color="gray.600" fontSize="sm">
            {children}
          </Box>
        </Box>
      </Stack>
    </Stack>
  );
};

const CardWithRightButton = () => {
  return (
    <Box as="section">
      <Box
        rounded="lg"
        borderWidth="2xs"
        borderColor="orange.100"
        bg="orange.50"
        shadow="sm"
        overflow="hidden"
      >
        <Box px={[5, 6]} py={[4, 5]}>
          <SubjectCreationTimer
            title="Complete this step within 24 hours"
            icon={<Icon as={BiTimer} color="orange.400" fontSize="5xl" />}
          >
            In order to submit your application for early review by our team,
            please aim to add and complete subjects as soon as possible.
          </SubjectCreationTimer>
        </Box>
      </Box>
    </Box>
  );
};

// export const SubjectPrompt: React.FC<{ store: ISubjectStore }> = observer(
//   ({ store }) => {
//     return <SubjectGroupSelection store={store} />
//   }
// );

export const SubjectPrompt: React.FC<{
  cantAddMoreSubjects?: boolean;
  incompleteSubjects?: any;
}> = ({ cantAddMoreSubjects, incompleteSubjects }) => {
  return (
    <Alert
      status={cantAddMoreSubjects ? "error" : "warning"}
      variant="subtle"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      height="200px"
      rounded="xl"
    >
      <AlertIcon boxSize="40px" mr={0} />
      <AlertTitle mt={4} mb={1} fontSize="lg">
        {cantAddMoreSubjects
          ? "You can't add new subjects"
          : "Finish adding your subjects"}
      </AlertTitle>
      <AlertDescription maxWidth="sm">
        {cantAddMoreSubjects
          ? "You've reached the maximum number of subjects. If you have incomplete subjects, you can delete them to add new ones."
          : `You have ${pluralize(
              "pending subject",
              incompleteSubjects?.length,
              true,
            )} to complete. Scroll down to finish up and start getting bookings.`}
      </AlertDescription>
    </Alert>
  );
};
